import React, { FC } from "react";
import { YhAuth, IYhAuth } from "../YhAuth";
import { Button } from "antd";

interface IAuthButton extends IYhAuth {
    //定义组件接口
    //....
    name?: string,
    className?: string,
    icon?: JSX.Element
    type?: "link" | "text" | "ghost" | "default" | "primary" | "dashed" | undefined,
    shape?: "round" | "circle" | undefined,
    onClick?: ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined,
    children?: JSX.Element
}

//本示例只做权限组件进一步封装演示
export const AuthButton: FC<IAuthButton> = ({
    resCode,
    name,
    className = "mr-5",
    type = "link",
    shape = "round",
    onClick = () => null,
    icon,
    children = <Button className={className} type={type} onClick={onClick} shape={shape}>{icon}{name}</Button>,
}) => {
    return (<YhAuth resCode={resCode}>
        {children}
        {/* <Button>
            ...
        </Button> */}
    </YhAuth>)
}